import React from 'react'
import { AppRegionEnum } from './types/app-region.enum'
import device from 'current-device'

export function getScrollTop(): number {
  const body = document?.body
  const docEl = document?.documentElement
  return (
    (window.pageYOffset || docEl?.scrollTop || body?.scrollTop || 0) -
    (docEl?.clientTop || 0)
  )
}

export const isBrowser = (): boolean => typeof window !== 'undefined'

export const toLink = (link: string) => {
  window.open(link)
}

export const getMailUrl = (hostName: string, region: AppRegionEnum) => {
  const mailUrlSgnl = `${
    process.env.NODE_ENV === 'production'
      ? `https://msg.${hostName.slice(-8)}`
      : 'https://message.sgnl.dev'
  }/api/public/mail/sgnl`

  const mailUrlSgnx = `https://api.emailjs.com/api/v1.0/email/send-form`

  return region === AppRegionEnum.Ru ? mailUrlSgnl : mailUrlSgnx
}

export const createFillArray = <T,>(
  length: number,
  fillCb: (i: number) => T
): T[] =>
  Array(length)
    .fill(0)
    .map((_, i) => fillCb(i))

export const areSetsEqual = (a: Set<number>, b: Set<number>) => {
  if (a.size !== b.size) return false
  for (const val of Array.from(a)) {
    if (!b.has(val)) return false
  }
  return true
}

export const getDeviceLink = ({
  iosLink,
  androidLink,
  desktopLink,
}: {
  iosLink: string
  androidLink: string
  desktopLink: string
}) => {
  if (typeof device.ios === 'function' && device.ios()) {
    return iosLink
  } else if (typeof device.android === 'function' && device.android()) {
    return androidLink
  }
  return desktopLink
}

export const getIframeYoutubeSrc = (videoId: string) => {
  return `https://www.youtube.com/embed/${videoId}?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=0&amp;disablekb=1&amp;modestbranding=1`
}

export const renderTextWithHighlight = (
  text: string,
  highlightTextWordsByIdx?: number[],
  classNameHighlightText?: string
) => {
  if (highlightTextWordsByIdx?.length) {
    return text
      .split(' ')
      .map((t, idx) => (
        <React.Fragment key={t + idx}>
          {highlightTextWordsByIdx.includes(idx) ? (
            <span className={classNameHighlightText}>{`${t} `}</span>
          ) : (
            `${t} `
          )}
        </React.Fragment>
      ))
  }

  return <React.Fragment>{text}</React.Fragment>
}
